import styled from "styled-components";
import {
  FaFacebook,
  FaTwitter,
  FaPinterest,
  FaInstagram,
  FaYoutube,
  FaEnvelope,
} from "react-icons/fa";

function Footer() {
  const actualYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <Rights>
        Copyright &copy; {actualYear} Todos los derechos reservados a{" "}
        <span>Green and Fit</span>
        <a href="mailto: greenandfithn@gmail.com">
          <FaEnvelope /> <span>greenandfithn@gmail.com</span>
        </a>
      </Rights>
      <Social>
        <a href="#!" target="_blank" rel="noopener noreferrer">
          <FaFacebook color="#3b5998" />
        </a>
        <a href="#!" target="_blank" rel="noopener noreferrer">
          <FaTwitter color="#1da1f2" />
        </a>
        <a href="#!" target="_blank" rel="noopener noreferrer">
          <FaPinterest color="#bd081c" />
        </a>
        <a href="#!" target="_blank" rel="noopener noreferrer">
          <FaInstagram color="#c32aa3" />
        </a>
        <a href="#!" target="_blank" rel="noopener noreferrer">
          <FaYoutube color="#ff0000" />
        </a>
      </Social>
    </FooterContainer>
  );
}

const FooterContainer = styled.footer`
  width: 100%;
  height: 5rem;
  margin-top: 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
`;

const Rights = styled.div`
  color: #0d0d0d;
  font-weight: 300;
  span {
    font-weight: 500;
  }

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    text-decoration: none;
    color: #034001;
    &:hover {
      color: #055902;
    }
    span {
      margin-left: 10px;
    }
  }
`;

const Social = styled.div`
  width: 300px;
  margin-top: 5px;
  display: flex;
  justify-content: space-evenly;
  font-size: 30px;
`;

export default Footer;
